<template>
<div class="profileItem" data-edit="false">
  <div class="profileItem__label">
    {{ label }}
    <span class="profileItem__desc" v-if="labelDesc">{{ labelDesc }}</span>
  </div>
  <div class="profileItem__detail">
    <div v-if="!isEdit" class="profileItem__view">
      <span class="profileItem__value"
        :data-empty="!value">{{ value || '設定されていません' }}
      </span>
      <button type="button"
        class="btn"
        data-size="xs"
        data-color="primary"
        @click="toggleEdit"
      ><i class="material-icons">edit</i></button>
    </div>
    <div v-if="isEdit" class="profileItem__field">
      <div class="profileItem__input">
        <div v-if="type === 'text'">
          <input ref="input" type="text" v-model="newValue">
        </div>
        <div v-else-if="type === 'date'">
          <form-date
            name="birthday"
            v-model="newValue"
          ></form-date>
        </div>
        <span class="profileItem__inputBorder"></span>
      </div>
      <button type="button"
        class="btn"
        data-size="xs"
        data-color="primary"
        @click="update"
      >更新</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'profile-item',
  props: {
    name: { type: String, required: true },
    type: { type: String, default: 'text' },
    label: { type: String, default: '' },
    labelDesc: { type: String, default: '' },
    value: { type: String || Number, default: '' }
  },
  data() {
    return {
      isEdit: false,
      newValue: this.value
    }
  },
  methods: {
    toggleEdit() {
      this.isEdit = !this.isEdit
      if (this.isEdit) {
        setTimeout(() => {
          if (this.$refs.input) {
            this.$refs.input.focus()
          }
        }, 100)
      }
    },
    update() {
      this.$emit('update', { [this.name]: this.newValue })
      this.isEdit = false
    }
  }
}</script>

<style lang="scss">
.profileItem {
  margin-bottom: 20px;
  &__label {
    font-size: 14px;
    color: #8cc63f;
    font-weight: bold;

  }
  &__desc {
    font-size: 12px;
    color: #898989;
    font-weight: normal;
  }
  &__view,
  &__field {
    height: 44px;
    display: flex;
    align-items: center;
    position: relative;
  }
  &__value {
    flex: 1 1 100%;
    &[data-empty='true'] {
      opacity: .5;
    }
  }
  &__input {
    flex: 1 1 100%;
    > input, select {
      -webkit-appearance: none;
      border: 0;
      height: 36px;
      font-size: 16px;
      padding: 0 8px;
      outline: none;
      &:focus + .profileItem__inputBorder::after {
        transform: scale(1, 1)
      }
    }
  }
  &__inputBorder {
    &::before,
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      display: block;
      height: 1px;
      background: #DCDCDC;
      z-index: 1;
    }
    &::after {
      height: 2px;
      background: #8cc63f;
      transform-origin: left center;
      transform: scale(0, 1);
      transition: transform 150ms ease-in-out;
      will-change: transform;
      z-index: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ProfileItem.vue